
import React, {useState, useEffect, useContext,useRef} from "react";
import {useHistory,useParams} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";


import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";
import { UserLoginContext } from "../../context/UserLoginContext";
import { CollectionsContext } from "../../context/CollectionsContext";

const GeneralImagesTable = () => {
    //Grab the collection ID!
    const { collectionId } = useParams();
    const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();
    const [data, setData] = React.useState([]);

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    // Update table data whenever general images change
    useEffect(() => {
        if (userState.status && collectionsState.generalImages && Array.isArray(collectionsState.generalImages)) {
            const tableData = collectionsState.generalImages.map((theImage, i) => {
                return {
                    id: theImage._id,
                    Title: theImage.Title,
                    Description: theImage.Description,
                    Location: theImage.Location,
                    Caption: theImage.Caption,
                    Image: theImage.Image,

                    actions: (
                        // we've added some custom button actions
                        <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Image</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            generalImage: theImage}));
                                        let tURL = "/admin/editgeneralimage/" + collectionId;
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to remove the data row */}
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Image</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        _deleteImageAlert(theImage._id);
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [collectionsState.generalImages, userState.status, collectionId]);

    useEffect(() => {
        const getImages = async () => {
            //console.log(collectionId);
            let tempURL = rest.generalImages + '/' + collectionId;
            const generalImagesList = await authenticatedFetch(tempURL, {
                method: 'GET'
            });
            const generalImagesData = await generalImagesList.json();
            //console.log(generalImagesData);
            setCollectionsState((prevcollectionsState) => ({
                ...prevcollectionsState,
                generalImages: generalImagesData
            }));
            //setQuestions(questionsList);
            //console.log("Data from Fetch:");
            //console.log(questionsState.theQuestions);
        };
        if (userState.apiKey && collectionId) {
            getImages(); // run it, run it
        }
    }, [collectionId, userState.apiKey]);

    const _delete_image = async (id) => {
        // Backend now handles both Cloudinary and MongoDB deletion
        try {
            const tempURL = rest.generalImage + '/' + id;
            const deleteResponse = await authenticatedFetch(tempURL, {
                method: 'DELETE'
            });

            if (!deleteResponse.ok) {
                const errorData = await deleteResponse.json();
                throw new Error(errorData.message || 'Failed to delete image');
            }

            notify("success", "Image has been deleted successfully!");

            // Re-fetch images to refresh the table
            const generalImagesURL = rest.generalImages + '/' + collectionId;
            const generalImagesList = await authenticatedFetch(generalImagesURL, {
                method: 'GET'
            });
            const generalImagesData = await generalImagesList.json();
            setCollectionsState((prevcollectionsState) => ({
                ...prevcollectionsState,
                generalImages: generalImagesData
            }));
        } catch (error) {
            console.error('Error deleting image:', error);
            notify("danger", error.message || 'Failed to delete image.');
        }
    };

    const _deleteImageAlert = async (id) => {
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => {
                    _delete_image(id);
                    setalert(null);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to delete this image?
            </SweetAlert>
        );
    };
    if (userState.status) {
        return (
            <>
                <div className="rna-container">
                    <NotificationAlert ref={notificationAlertRef} />
                </div>
                <div className="content">
                    <Col md={8} className="ml-auto mr-auto">
                        <h2 className="text-center">General Collection Images</h2>
                        <p className="text-center">
                            Collection Name: {collectionsState.generalCollection.Title}
                        </p>
                    </Col>
                    <Row className="mt-5">
                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <CardTitle tag="h4">Images</CardTitle>
                                        </Col>
                                        <Col md="6" className="text-right">
                                            <Button
                                                color="secondary"
                                                onClick={() => history.push("/admin/generalcollections")}
                                                className="animation-on-hover"
                                                style={{marginRight: "10px"}}
                                            >
                                                <i className="tim-icons icon-minimal-left"/> Back to Gallery
                                            </Button>
                                            <Button
                                                color="info"
                                                onClick={() => history.push("/admin/addgeneralimage/" + collectionId)}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-simple-add"/> Add Image
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Description",
                                                accessor: "Description"
                                            },
                                            {
                                                Header: "Location",
                                                accessor: "Location"
                                            },
                                            {
                                                Header: "Caption",
                                                accessor: "Caption"
                                            },
                                            {
                                                Header: "Image",
                                                Cell: (props) => {
                                                    return <div><img height={100} src={props.row.original.Image}/></div>;
                                                },
                                                sortable: false,
                                                filterable: false
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {alert}
                </div>
            </>

        );
    }

    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};

export default GeneralImagesTable;
